export default "__VITE_ASSET__CBGwleVf__"